import { render, staticRenderFns } from "./TableDispatchLocation.vue?vue&type=template&id=2e2d4675&"
import script from "./TableDispatchLocation.vue?vue&type=script&lang=ts&"
export * from "./TableDispatchLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports